<template>
  <div class="order_wrap">
    <div class="order_head">
      <h5>주문조회</h5>
      <p>주문번호를 클릭하시면 주문 상세를 확인하실 수 있습니다.</p>
    </div>
    <div class="order_body">
      <div class="check_area">
        <div class="select_box">
          <button type="button" class="btn_select">전체상태</button>
          <ul class="select_list">
            <li><button>번호</button></li>
            <li><button>제목</button></li>
          </ul>
        </div>
        <ul class="date_filter">
          <li v-for="(day, index) in dayOptions" :key="index">
            <a
              @click="selectDaysAgo(day.value)"
              :class="{ active: daysAgo === day.value }"
            >
              {{ day.text }}
            </a>
          </li>
        </ul>
        <div class="date_input">
          <input type="date" v-model="startDate" />
          <span>~</span>
          <input type="date" v-model="endDate" />
          <button @click="selectBetweenDate" type="button">조회</button>
        </div>
      </div>
      <div class="tbl_wrap">
        <table>
          <caption>
            최근 주문내역
          </caption>
          <colgroup>
            <col style="width: 20%" />
            <col style="width: 40%" />
            <col style="width: 20%" />
            <col style="width: 15%" />
            <col style="width: 10%" />
            <col style="width: 15%" />
          </colgroup>
          <thead>
            <tr>
              <th>주문일자</th>
              <th>상품명</th>
              <th>판매금액</th>
              <th>행사장</th>
              <th>기부화환</th>
              <th>비 고</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="invitation in invitations"
              :key="invitation.invitationSeq"
            >
              <td>
                <div class="order_date">{{ invitation.createDate }}</div>
                <div class="product_num">({{ invitation.orderNum }})</div>
              </td>
              <td>
                <div class="product_info">
                  <div class="product_photo">
                    <img
                      :src="
                        invitation.filePath
                          ? $getImgUrl(invitation.filePath)
                          : require('../../../assets/images/common/campaign_img_01.png')
                      "
                      alt=""
                    />
                  </div>
                  <div class="product_tit">
                    <p v-if="invitation.useCampaign">
                      [{{ invitation.categoryName }}]
                    </p>
                    <div>
                      {{
                        invitation.useCampaign
                          ? invitation.campaignName
                          : "기부화환 미적용"
                      }}
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="product_price">
                  {{
                    invitation.campaignAmount === 0
                      ? "-"
                      : $addComma(invitation.campaignAmount) + "원"
                  }}
                </div>
              </td>
              <td>
                <div class="place">
                  {{ invitation.eventLocationName }}
                  <span>({{ invitation.eventLocationDtl }})</span>
                </div>
              </td>
              <td>
                <div class="count">10</div>
              </td>
              <td>
                <a
                  v-bind:href="'/invitation/' + invitation.orderNum"
                  class="btn_view"
                  target="_blank"
                  >{{ invitation.isWedding ? "청첩장" : "부고장" }} 보기</a
                >
                <a
                  @click="toEdit(invitation)"
                  class="btn_view"
                  target="_blank"
                  >{{ invitation.isWedding ? "청첩장" : "부고장" }} 수정</a
                >
                <a href="" class="btn_review" style="display: none">상품평</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

const invitationModule = "invitationModule";

export default {
  data() {
    return {
      dayOptions: [
        { text: "전체", value: null },
        { text: "오늘", value: 0 },
        { text: "10일", value: 10 },
        { text: "30일", value: 30 },
        { text: "60일", value: 60 },
        { text: "90일", value: 90 },
      ],

      currentPage: 1,
      daysAgo: null,
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
      currentPage: 1,
    };
  },

  methods: {
    ...mapActions(invitationModule, [
      "requestInvitationListByDaysAgo",
      "requestInvitationListByBetween",
    ]),

    async selectDaysAgo(daysAgo) {
      this.daysAgo = daysAgo;

      const { currentPage } = this;
      await this.requestInvitationListByDaysAgo({ currentPage, daysAgo });
    },

    async selectBetweenDate() {
      const { currentPage, startDate, endDate } = this;
      await this.requestInvitationListByBetween({
        currentPage,
        startDate,
        endDate,
      });
    },

    toEdit(invitation) {
      const isWedding = invitation.isWedding
      if (isWedding) {
        this.$router.push({ name: 'WeddingInvitationEditPage', params: {weddingInvitationSeq: invitation.invitationSeq} })
      } else {
        this.$router.push({ name: 'FuneralInvitationEditPage', params: {funeralInvitationSeq: invitation.invitationSeq} })
      }
    }
  },

  computed: {
    ...mapState(invitationModule, ["invitations", "invitationCount"]),
  },

  async mounted() {
    const { currentPage, daysAgo } = this;
    await this.requestInvitationListByDaysAgo({ currentPage, daysAgo });
  },
};
</script>
